import { Stack, Text, useMediaQuery } from '@chakra-ui/react'
import React from 'react'
import UserMenu from './UserMenu'

type Props = {
  mediaQuery?: string
  children?: React.ReactNode
  title?: string
}

const Header: React.FC<Props> = ({
  children,
  mediaQuery = '(max-width: 1200px)',
  title,
}) => {
  const [isMobileHeader] = useMediaQuery(mediaQuery)

  return isMobileHeader ? (
    <>{children}</>
  ) : (
    <Stack direction="row" justify="space-between" mb="24px">
      {title ? (
        <Stack direction="row" w="full">
          <Text color="text.dark" fontSize="24px" fontWeight={700} lineHeight="30px">
            {title}
          </Text>
        </Stack>
      ) : null}
      <Stack direction="row" justify={children ? 'space-between' : 'flex-end'} w="full">
        {children}
        <UserMenu />
      </Stack>
    </Stack>
  )
}

export default Header